import { render, staticRenderFns } from "./dv-full-screen.vue?vue&type=template&id=3a982368"
import script from "./dv-full-screen.vue?vue&type=script&lang=js"
export * from "./dv-full-screen.vue?vue&type=script&lang=js"
import style0 from "./dv-full-screen.vue?vue&type=style&index=0&id=3a982368&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports